import React, { useCallback, useEffect, useState } from "react";
import TourGuideModal, {
  clearTourPendingFirstOpen,
  isFirstTimeTourCompleted,
  isTourPendingFirstOpen,
} from "./TourGuideModal";
import { TOUR_OPEN_EVENT } from "../../constants/tourSteps";

export function openAppTour() {
  try {
    window.dispatchEvent(new CustomEvent(TOUR_OPEN_EVENT, { detail: { replay: true } }));
  } catch (error) {
    // ignore dispatch failures
  }
}

export default function TourGuideGate() {
  const [open, setOpen] = useState(false);
  const [isReplay, setIsReplay] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(false);

  const openPendingFirstTimeTour = useCallback(() => {
    if (isFirstTimeTourCompleted()) {
      clearTourPendingFirstOpen();
      return false;
    }
    if (!isTourPendingFirstOpen()) return false;

    setIsReplay(false);
    setIsFirstTime(true);
    setOpen(true);
    return true;
  }, []);

  useEffect(() => {
    const handleOpen = (event) => {
      const replay = Boolean(event?.detail?.replay);
      const firstTime = Boolean(event?.detail?.firstTime);

      // Post-signup Welcome tour auto-open is disabled (Introduction replaces it).
      // Replay from Settings ("Replay App Tour") still works via detail.replay.
      if (firstTime && !replay) {
        clearTourPendingFirstOpen();
        return;
      }

      if (firstTime && isFirstTimeTourCompleted()) {
        clearTourPendingFirstOpen();
        return;
      }

      setIsReplay(replay);
      setIsFirstTime(firstTime);
      setOpen(true);
    };

    window.addEventListener(TOUR_OPEN_EVENT, handleOpen);
    // --- Disabled: auto-open first-time tour after signup (Introduction screen used instead) ---
    // openPendingFirstTimeTour();

    return () => {
      window.removeEventListener(TOUR_OPEN_EVENT, handleOpen);
    };
  }, [openPendingFirstTimeTour]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setIsReplay(false);
    setIsFirstTime(false);
  }, []);

  if (!open) return null;

  return (
    <TourGuideModal
      open={open}
      onClose={handleClose}
      isReplay={isReplay}
      isFirstTime={isFirstTime}
    />
  );
}
